import Plyr from 'plyr'

const players = Plyr.setup('.js-oembed-player');

export default players